/**
 * The empty-response guard.
 *
 * A finished assistant turn that produced no visible text, no tool activity and
 * no files would otherwise render as a blank bubble — the "Meridian didn't
 * respond" failure. Show a fallback line instead, but NEVER on the actively-
 * streaming last row, so it cannot flash before the first token arrives.
 *
 * Pure so the predicate can be exercised without rendering a message.
 */

/** Shown when an assistant turn finished without producing any visible answer. */
export const EMPTY_RESPONSE_FALLBACK_TEXT =
  "I wasn't able to generate a response to that. Please try rephrasing, or ask again in a moment.";

export interface EmptyResponseInput {
  isUser: boolean;
  hasVisibleText: boolean;
  toolCount: number;
  segmentCount: number;
  fileCount: number;
  isLastMessage: boolean;
  isBusy: boolean;
}

export function shouldShowEmptyResponseFallback({
  isUser,
  hasVisibleText,
  toolCount,
  segmentCount,
  fileCount,
  isLastMessage,
  isBusy,
}: EmptyResponseInput): boolean {
  return (
    !isUser &&
    !hasVisibleText &&
    toolCount === 0 &&
    segmentCount === 0 &&
    fileCount === 0 &&
    !(isLastMessage && isBusy)
  );
}
